import React, { useEffect, useRef } from "react";
import {
  makeStyles,
  Button,
  Box,
  LinearProgress,
  FormControl,
  InputLabel,
  MenuItem,
  DialogActions,
  Dialog,
  DialogContent,
  Typography,
  IconButton,
  withStyles,
  Slide,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import SaveIcon from "@material-ui/icons/Save";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import { useDispatch, useSelector } from "react-redux";
import { Field, Form, Formik } from "formik";
import NumberFormat from "react-number-format";
import PropTypes from "prop-types";
import _ from "lodash";
import { TextField } from "formik-material-ui";
import CustomSelectInput from "../../inputs/CustomSelectInput";
import { updatePurchaseExpense } from "../../../redux/actions/purchaseRequest.action";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 600,
    padding: 1,
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "25ch",
    },
    "& .MuiBox-root": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
  selectInputForm: {
    width: "35ch",
  },
  inputForm: {
    width: "35ch",
  },
}));

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    overflowX: "auto",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const NumberFormatCustom = (props) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix=""
    />
  );
};

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ExpenseModalComponent({
  openModal,
  handleCloseModal,
  headerId,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const form = useRef();

  const { currencies } = useSelector((state) => state.referenceReducer);

  const { purchaseRequesteExpense } = useSelector(
    (state) => state.purchaseRequestReducer
  );

  useEffect(() => {
    if (form.current) {
      form.current.getFormikActions().validateForm();
    }

    return () => {};
  }, []);

  const findExchangeRate = (id) => {
    let result = _.find(currencies.data, { CURRENCY_ID: id });
    if (result) {
      return result.CURRENCY_EXC_ID;
    }
    return 0;
  };

  const renderCurrency = () => {
    return currencies.data.map((i) => (
      <MenuItem key={i.CURRENCY_ID} value={i.CURRENCY_ID}>
        {i.CURRENCY_EXC_CODE} - {i.CURRENCY_EXC_NAME}
      </MenuItem>
    ));
  };

  let submitExpenseForm = null;

  const handleSubmitMyForm = (e, status) => {
    if (submitExpenseForm) {
      submitExpenseForm(e, status);
    }
  };

  const bindSubmitForm = (submitForm) => {
    submitExpenseForm = submitForm;
  };

  const renderForm = () => {
    if (purchaseRequesteExpense.isLoading) {
      return <LinearProgress color="secondary" />;
    }

    return (
      <Formik
        ref={form}
        enableReinitialize
        initialValues={{
          ...purchaseRequesteExpense.data,
          PREXIDX: purchaseRequesteExpense.data
            ? purchaseRequesteExpense.data.PREXIDX
            : "",
          EXP01_AMOUNT: purchaseRequesteExpense.data
            ? purchaseRequesteExpense.data.EXP01_AMOUNT
            : "",
          EXP01_CURR_ID: purchaseRequesteExpense.data
            ? purchaseRequesteExpense.data.EXP01_CURR_ID
            : "",
          EXP01_EXC_RATE: purchaseRequesteExpense.data
            ? purchaseRequesteExpense.data.EXP01_EXC_RATE
            : "",
          EXP02_AMOUNT: purchaseRequesteExpense.data
            ? purchaseRequesteExpense.data.EXP02_AMOUNT
            : "",
          EXP02_CURR_ID: purchaseRequesteExpense.data
            ? purchaseRequesteExpense.data.EXP02_CURR_ID
            : "",
          EXP02_EXC_RATE: purchaseRequesteExpense.data
            ? purchaseRequesteExpense.data.EXP02_EXC_RATE
            : "",
          EXP03_AMOUNT: purchaseRequesteExpense.data
            ? purchaseRequesteExpense.data.EXP03_AMOUNT
            : "",
          EXP03_CURR_ID: purchaseRequesteExpense.data
            ? purchaseRequesteExpense.data.EXP03_CURR_ID
            : "",
          EXP03_EXC_RATE: purchaseRequesteExpense.data
            ? purchaseRequesteExpense.data.EXP03_EXC_RATE
            : "",
          EXP04_AMOUNT: purchaseRequesteExpense.data
            ? purchaseRequesteExpense.data.EXP04_AMOUNT
            : "",
          EXP04_CURR_ID: purchaseRequesteExpense.data
            ? purchaseRequesteExpense.data.EXP04_CURR_ID
            : "",
          EXP04_EXC_RATE: purchaseRequesteExpense.data
            ? purchaseRequesteExpense.data.EXP04_EXC_RATE
            : "",
        }}
        onSubmit={(values, { setSubmitting }) => {
          setTimeout(() => {
            let EXP01 = values.EXP01_EXC_RATE * values.EXP01_AMOUNT;
            let EXP02 = values.EXP02_EXC_RATE * values.EXP02_AMOUNT;
            let EXP03 = values.EXP03_EXC_RATE * values.EXP03_AMOUNT;
            let EXP04 = values.EXP04_EXC_RATE * values.EXP04_AMOUNT;

            values.AMOUNT = EXP01 + EXP02 + EXP03 + EXP04;

            dispatch(updatePurchaseExpense(values));

            handleCloseModal();

            setSubmitting(false);
          }, 500);
        }}
        validate={(values) => {
          const errors = {};

          if (!values.EXP01_AMOUNT && values.EXP01_CURR_ID) {
            errors.EXP01_AMOUNT = "Required";
          }

          if (values.EXP01_AMOUNT && !values.EXP01_CURR_ID) {
            errors.EXP01_CURR_ID = "Required";
          }

          if (!values.EXP02_AMOUNT && values.EXP02_CURR_ID) {
            errors.EXP02_AMOUNT = "Required";
          }

          if (values.EXP02_AMOUNT && !values.EXP02_CURR_ID) {
            errors.EXP02_CURR_ID = "Required";
          }

          if (!values.EXP03_AMOUNT && values.EXP03_CURR_ID) {
            errors.EXP03_AMOUNT = "Required";
          }

          if (values.EXP03_AMOUNT && !values.EXP03_CURR_ID) {
            errors.EXP03_CURR_ID = "Required";
          }

          if (!values.EXP04_AMOUNT && values.EXP04_CURR_ID) {
            errors.EXP04_AMOUNT = "Required";
          }

          if (values.EXP04_AMOUNT && !values.EXP04_CURR_ID) {
            errors.EXP04_CURR_ID = "Required";
          }

          return errors;
        }}
      >
        {(formikProps) => {
          const {
            submitForm,
            isSubmitting,
            touched,
            errors,
            values,
            setFieldValue,
          } = formikProps;

          bindSubmitForm(submitForm);

          return (
            <Form noValidate>
              <div>
                <Box display="flex" flexDirection="column">
                  <Box display="flex" justifyContent="space-between">
                    <Field
                      component={TextField}
                      name="EXP01_AMOUNT"
                      label="(+) Storeage"
                      error={Boolean(
                        errors.EXP01_AMOUNT &&
                          touched.EXP01_AMOUNT &&
                          errors.EXP01_AMOUNT
                      )}
                      className={classes.inputForm}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        inputComponent: NumberFormatCustom,
                      }}
                    />
                    <FormControl className={classes.selectInputForm}>
                      <InputLabel
                        error={Boolean(
                          errors.EXP01_CURR_ID &&
                            touched.EXP01_CURR_ID &&
                            errors.EXP01_CURR_ID
                        )}
                        id="EXP01_CURR_ID"
                      >
                        Select Currency Storeage
                      </InputLabel>
                      <Field
                        labelId="EXP01_CURR_ID"
                        component={CustomSelectInput}
                        name="EXP01_CURR_ID"
                        className={classes.selectInputForm}
                        error={Boolean(
                          errors.EXP01_CURR_ID &&
                            touched.EXP01_CURR_ID &&
                            errors.EXP01_CURR_ID
                        )}
                        onChange={(e) => {
                          setFieldValue(
                            "EXP01_EXC_RATE",
                            findExchangeRate(e.target.value)
                          );
                        }}
                      >
                        {renderCurrency()}
                      </Field>
                    </FormControl>
                  </Box>
                  <Box display="flex" justifyContent="space-between">
                    <Field
                      component={TextField}
                      name="EXP02_AMOUNT"
                      label="(+) Insurance"
                      error={Boolean(
                        errors.EXP02_AMOUNT &&
                          touched.EXP02_AMOUNT &&
                          errors.EXP02_AMOUNT
                      )}
                      className={classes.inputForm}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        inputComponent: NumberFormatCustom,
                      }}
                    />
                    <FormControl className={classes.selectInputForm}>
                      <InputLabel
                        error={Boolean(
                          errors.EXP02_CURR_ID &&
                            touched.EXP02_CURR_ID &&
                            errors.EXP02_CURR_ID
                        )}
                        id="EXP02_CURR_ID"
                      >
                        Select Currency Insurance
                      </InputLabel>
                      <Field
                        labelId="EXP02_CURR_ID"
                        component={CustomSelectInput}
                        name="EXP02_CURR_ID"
                        className={classes.selectInputForm}
                        error={Boolean(
                          errors.EXP02_CURR_ID &&
                            touched.EXP02_CURR_ID &&
                            errors.EXP02_CURR_ID
                        )}
                        onChange={(e) => {
                          setFieldValue(
                            "EXP02_EXC_RATE",
                            findExchangeRate(e.target.value)
                          );
                        }}
                      >
                        {renderCurrency()}
                      </Field>
                    </FormControl>
                  </Box>
                  <Box display="flex" justifyContent="space-between">
                    <Field
                      component={TextField}
                      name="EXP03_AMOUNT"
                      label="(+) Import duty"
                      error={Boolean(
                        errors.EXP03_AMOUNT &&
                          touched.EXP03_AMOUNT &&
                          errors.EXP03_AMOUNT
                      )}
                      className={classes.inputForm}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        inputComponent: NumberFormatCustom,
                      }}
                    />
                    <FormControl className={classes.selectInputForm}>
                      <InputLabel
                        error={Boolean(
                          errors.EXP03_CURR_ID &&
                            touched.EXP03_CURR_ID &&
                            errors.EXP03_CURR_ID
                        )}
                        id="EXP03_CURR_ID"
                      >
                        Select Currency Import duty
                      </InputLabel>
                      <Field
                        labelId="EXP03_CURR_ID"
                        component={CustomSelectInput}
                        name="EXP03_CURR_ID"
                        className={classes.selectInputForm}
                        error={Boolean(
                          errors.EXP03_CURR_ID &&
                            touched.EXP03_CURR_ID &&
                            errors.EXP03_CURR_ID
                        )}
                        onChange={(e) => {
                          setFieldValue(
                            "EXP03_EXC_RATE",
                            findExchangeRate(e.target.value)
                          );
                        }}
                      >
                        {renderCurrency()}
                      </Field>
                    </FormControl>
                  </Box>
                  <Box display="flex" justifyContent="space-between">
                    <Field
                      component={TextField}
                      name="EXP04_AMOUNT"
                      label="(+) Other expense"
                      error={Boolean(
                        errors.EXP04_AMOUNT &&
                          touched.EXP04_AMOUNT &&
                          errors.EXP04_AMOUNT
                      )}
                      className={classes.inputForm}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        inputComponent: NumberFormatCustom,
                      }}
                    />
                    <FormControl className={classes.selectInputForm}>
                      <InputLabel
                        error={Boolean(
                          errors.EXP04_CURR_ID &&
                            touched.EXP04_CURR_ID &&
                            errors.EXP04_CURR_ID
                        )}
                        id="EXP04_CURR_ID"
                      >
                        Select Currency Other expense
                      </InputLabel>
                      <Field
                        labelId="EXP04_CURR_ID"
                        component={CustomSelectInput}
                        name="EXP04_CURR_ID"
                        className={classes.selectInputForm}
                        error={Boolean(
                          errors.EXP04_CURR_ID &&
                            touched.EXP04_CURR_ID &&
                            errors.EXP04_CURR_ID
                        )}
                        onChange={(e) => {
                          setFieldValue(
                            "EXP04_EXC_RATE",
                            findExchangeRate(e.target.value)
                          );
                        }}
                      >
                        {renderCurrency()}
                      </Field>
                    </FormControl>
                  </Box>
                </Box>
              </div>
            </Form>
          );
        }}
      </Formik>
    );
  };

  return (
    <div className={classes.modal}>
      <Dialog
        onClose={handleCloseModal}
        aria-labelledby="customized-dialog-title"
        TransitionComponent={Transition}
        open={openModal}
        disableBackdropClick
      >
        <DialogTitle id="customized-dialog-title" onClose={handleCloseModal}>
          Add Expense
        </DialogTitle>
        <DialogContent dividers>
          <Box display="flex" component="div" flexDirection="column">
            <Box>{renderForm()}</Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            variant="contained"
            color="primary"
            onClick={(e) => {
              handleSubmitMyForm(e);
            }}
          >
            <SaveIcon />
            Save
          </Button>
          <Button
            autoFocus
            variant="contained"
            color="second"
            onClick={(e) => {
              handleCloseModal();
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
